/**
* $.integerInput
*/

$(function($) {
    var Key = {
        MINUS: 45,
        ZERO: 48,
        NINE: 57
    };

    $.fn.integerInput = function(negative) {
        return this.each(function() {
            negative = (negative || false);

            var target = $(this);

            target.bind('input', function() {
                var value = target.val();
                var integerValue = '';

                for(var i in value) {
                    if(negative && !integerValue.length && value[i].charCodeAt(0) == Key.MINUS) {
                        integerValue += value[i];
                        continue;
                    }

                    if(value[i].charCodeAt(0) >= Key.ZERO && value[i].charCodeAt(0) <= Key.NINE) {
                        integerValue += value[i];
                    }
                }

                target.val(integerValue);
            });
        });
    }
}(jQuery));

/**
* $.floatInput
*/

$(function($) {
    var Key = {
        MINUS: 45,
        POINT: 46,
        ZERO: 48,
        NINE: 57
    };

    $.fn.floatInput = function(negative) {
        return this.each(function() {
            negative = (negative || false);

            var target = $(this);

            target.bind('input', function() {
                var value = target.val();
                var floatValue = '';
                var decimalMark = false;

                for(var i in value) {
                    if(negative && !floatValue.length && value[i].charCodeAt(0) == Key.MINUS) {
                        floatValue += value[i];
                        continue;
                    }

                    if(!decimalMark && value[i].charCodeAt(0) == Key.POINT) {
                        floatValue += value[i];
                        decimalMark = true;
                        continue;
                    }

                    if(value[i].charCodeAt(0) >= Key.ZERO && value[i].charCodeAt(0) <= Key.NINE) {
                        floatValue += value[i];
                    }
                }

                target.val(floatValue);
            });
        });
    }
}(jQuery));

/**
* $.highlight
* $.removeHighlight
*/

$(function($) {
    $.fn.highlight = function(color, options) {
        if($.inArray(color, ['green', 'red', 'yellow']) == -1) {
            color = 'red';
        }

        options = $.extend({
            animation: true,
            autoHide: 0,
            hideEvent: 'focus',
            html: false,
            icon: false,
            offset: [0, 0],
            placement: 'top',
            text: 'Message goes here!'
        }, options);

        return this.each(function() {
            var target = $(this);
            var parent = target.parent();
            var tooltip = null;
            var wrapper = null;
            var wrapperUniqueId = Math.random().toString(36).substr(2, 8);

            if(target.data('highlight-tooltip-id')) {
                target.removeHighlight();
            }

            // parent
            if($.inArray(parent.css('position'), ['static', 'initial', 'inherit']) >= 0) {
                parent.css('position', 'relative');
            }

            // wrapper + tooltip
            wrapper = $('<div class="highlight-tooltip" id="' + wrapperUniqueId + '"></div>').appendTo(parent);
            tooltip = $('<div class="' + color + (options.animation ? ' hidden' : '') + '"></div>').appendTo(wrapper);

            if(options.html) {
                tooltip.html(options.html);
            }
            else {
                tooltip.text(options.text);
            }

            if(options.icon) {
                tooltip.prepend('<div class="icon ' + color + '"></div>');
            }

            switch(options.placement) {
                case 'bottom':
                    wrapper.css({
                        left: (target.position().left + parseInt(target.css('margin-left')) + Math.round((target.outerWidth() - 2) * 0.5) + options.offset[0]) + 'px',
                        top: (target.position().top + parseInt(target.css('margin-top')) + Math.round(target.outerHeight() - 2) + options.offset[1]) + 'px'
                    });
                    tooltip.addClass('bottom').css({ left: Math.round(tooltip.outerWidth() * -0.5 + 1) + 'px' });
                    break;

                case 'left':
                    wrapper.css({
                        left: (target.position().left + parseInt(target.css('margin-left')) + 0 + options.offset[0]) + 'px',
                        top: (target.position().top + parseInt(target.css('margin-top')) + Math.round((target.outerHeight() - 2) * 0.5) + options.offset[1]) + 'px'
                    });
                    tooltip.addClass('left').css({ top: Math.round(tooltip.outerHeight() * -0.5 + 1) + 'px' });
                    break;

                case 'right':
                    wrapper.css({
                        left: (target.position().left + parseInt(target.css('margin-left')) + Math.round(target.outerWidth() - 2) + options.offset[0]) + 'px',
                        top: (target.position().top + parseInt(target.css('margin-top')) + Math.round((target.outerHeight() - 2) * 0.5) + options.offset[1]) + 'px'
                    });
                    tooltip.addClass('right').css({ top: Math.round(tooltip.outerHeight() * -0.5 -15) + 'px' });
                    break;

                default:
                    wrapper.css({
                        left: (target.position().left + parseInt(target.css('margin-left')) + Math.round((target.outerWidth() - 2) * 0.5) + options.offset[0]) + 'px',
                        top: (target.position().top + parseInt(target.css('margin-top')) + 0 + options.offset[1]) + 'px'
                    });
                    tooltip.addClass('top').css({ left: Math.round(tooltip.outerWidth() * -0.5 + 1) + 'px' });
                    break;
            }

            // hide
            if(options.autoHide) {
                window.setTimeout(function() {
                    if(wrapper) {
                        wrapper.remove();
                        target.data('highlight-tooltip-id', '');
                    }
                }, options.autoHide);
            }
            else {
                var hideEvent = function(e) {
                    wrapper.remove();
                    target.unbind(options.hideEvent, hideEvent).data('highlight-tooltip-id', '');
                };

                target.bind(options.hideEvent, {}, hideEvent);
            }

            // init
            target.data('highlight-tooltip-id', wrapperUniqueId);
            tooltip.removeClass('hidden');
        });
    }

    $.fn.removeHighlight = function() {
        return this.each(function() {
            var target = $(this);

            if(target.data('highlight-tooltip-id')) {
                $('.highlight-tooltip#' + target.data('highlight-tooltip-id')).remove();
                target.data('highlight-tooltip-id', '');
            }
        });
    }
}(jQuery));


/**
* $.colorPicker
* $.removeColorPicker
*/

$(function($) {
    $.fn.colorPicker = function(options) {
        options = $.extend({
            animation: true,
            colors: ['red', 'blue', 'green'],
            columns: 4,
            disabledColors: [],
            hide: null,
            message: 'Pick a color:',
            offset: [0, 0],
            placement: 'top',
            selectedColor: null,
            show: null,
            select: null
        }, options);

        return this.each(function() {
            var target = $(this);
            var parent = target.parent();
            var wrapper = null;
            var wrapperUniqueId = Math.random().toString(36).substr(2, 8);
            var popover = null;
            var heading = null;
            var colors = null;

            if(target.data('color-picker-popover-id')) {
                target.removeColorPicker();
            }

            // parent
            if($.inArray(parent.css('position'), ['static', 'initial', 'inherit']) >= 0) {
                parent.css('position', 'relative');
            }

            // wrapper + popover
            wrapper = $('<div class="color-picker-popover" id="' + wrapperUniqueId + '"></div>').appendTo(parent);
            popover = $('<div class="' + (options.animation ? ' hidden' : '') + '"></div>').appendTo(wrapper);
            heading = $('<strong>' + options.message + '</strong>').appendTo(popover);
            colors = $('<div class="colors"></div>').appendTo(popover).css('width', (options.columns * 34) + 'px');

            for(var i in options.colors) {
                var item = $('<div data-color="' + options.colors[i] + '"><div style="background-color: ' + options.colors[i] + ';"></div></div>').appendTo(colors);

                if(options.colors[i] == options.selectedColor) {
                    item.addClass('selected');
                }
                else if($.inArray(options.colors[i], options.disabledColors) > -1) {
                    item.addClass('disabled');
                }
            }

            colors.find('div').bind('click', function() {
                if(!$(this).hasClass('disabled') && !$(this).hasClass('selected')) {
                    if(options.select) {
                        options.select($(this).data('color'));
                    }

                    if(options.hide) {
                        options.hide();
                    }

                    target.removeColorPicker();
                    $(document).unbind('click', hideEvent);
                }
            });

            switch(options.placement) {
                case 'bottom':
                    wrapper.css({
                        left: (target.position().left + parseInt(target.css('margin-left')) + Math.round((target.outerWidth() - 2) * 0.5) + options.offset[0]) + 'px',
                        top: (target.position().top + parseInt(target.css('margin-top')) + Math.round(target.outerHeight() - 2) + options.offset[1]) + 'px'
                    });
                    popover.addClass('bottom').css({ left: Math.round(popover.outerWidth() * -0.5 + 1) + 'px' });
                    break;

                case 'left':
                    wrapper.css({
                        left: (target.position().left + parseInt(target.css('margin-left')) + 0 + options.offset[0]) + 'px',
                        top: (target.position().top + parseInt(target.css('margin-top')) + Math.round((target.outerHeight() - 2) * 0.5) + options.offset[1]) + 'px'
                    });
                    popover.addClass('left').css({ top: Math.round(popover.outerHeight() * -0.5 + 1) + 'px' });
                    break;

                case 'right':
                    wrapper.css({
                        left: (target.position().left + parseInt(target.css('margin-left')) + Math.round(target.outerWidth() - 2) + options.offset[0]) + 'px',
                        top: (target.position().top + parseInt(target.css('margin-top')) + Math.round((target.outerHeight() - 2) * 0.5) + options.offset[1]) + 'px'
                    });
                    popover.addClass('right').css({ top: Math.round(popover.outerHeight() * -0.5 + 1) + 'px' });
                    break;

                default:
                    wrapper.css({
                        left: (target.position().left + parseInt(target.css('margin-left')) + Math.round((target.outerWidth() - 2) * 0.5) + options.offset[0]) + 'px',
                        top: (target.position().top + parseInt(target.css('margin-top')) + 0 + options.offset[1]) + 'px'
                    });
                    popover.addClass('top').css({ left: Math.round(popover.outerWidth() * -0.5 + 1) + 'px' });
                    break;
            }

            // hide
            var hideEvent = function(e) {
                if(!$(e.target).parents('.color-picker-popover').length) {
                    if(options.hide) {
                        options.hide();
                    }

                    target.removeColorPicker();
                    $(document).unbind('click', hideEvent);
                }
            };

            window.setTimeout(function() {
                $(document).bind('click', hideEvent);
            }, 100);

            // init
            target.data('color-picker-popover-id', wrapperUniqueId);
            popover.removeClass('hidden');

            if(options.show) {
                options.show();
            }
        });
    }

    $.fn.removeColorPicker = function() {
        return this.each(function() {
            var target = $(this);

            if(target.data('color-picker-popover-id')) {
                var picker = $('.color-picker-popover#' + target.data('color-picker-popover-id'));

                picker.css('opacity', 0);
                target.data('color-picker-popover-id', '');

                window.setTimeout(function() {
                    picker.remove();
                }, 100);
            }
        });
    }
}(jQuery));
